import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export function Field({ label, required, error, hint, children, className }) {
  return (
    <label className={cn("block space-y-1.5", className)}>
      <span className="text-sm font-medium text-foreground">
        {label}
        {required && <span className="ml-0.5 text-destructive" aria-hidden>*</span>}
      </span>
      {children}
      {error ? (
        <span className="flex items-center gap-1 text-xs text-destructive" role="alert"><AlertCircle className="h-3.5 w-3.5" />{error}</span>
      ) : hint ? <span className="text-xs text-muted-foreground">{hint}</span> : null}
    </label>
  );
}

export function Input({ error, className, ...props }) {
  return <input className={cn("fv-input", error && "fv-input-error", className)} {...props} />;
}

export function Select({ error, className, children, ...props }) {
  return <select className={cn("fv-input appearance-none", error && "fv-input-error", className)} {...props}>{children}</select>;
}

export function Textarea({ error, className, ...props }) {
  return <textarea className={cn("fv-input min-h-[88px] py-2", error && "fv-input-error", className)} {...props} />;
}
